import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router } from 'react-router-dom';
import { initializeIcons } from '@fluentui/react/lib/Icons';
import { LoadScreen } from './components/LoadScreen/LoadScreen';
import { UserContext } from './context/UserContext';
import MainNav from './Nav/MainNav';
import 'devextreme/dist/css/dx.light.css';
import { FacebookProvider, CustomChat } from 'react-facebook';
import { signalrHub } from './API/SignalRClient';
import { API } from './API/API';
import { locale, loadMessages } from "devextreme/localization";
import messagesMn from "./components/DevExLocalization/mn.json";

const App = () => {

  const [userInfo, setUserInfo] = useState({});

  const getUserData = () => {
    let userInfo = {};
    if (localStorage.getItem('userInfo')) {
      userInfo = JSON.parse(localStorage.getItem('userInfo'));
    }
    setUserInfo(userInfo);
  }

  const onRefreshPermission = async () => {

    let tUserInfo = {};
    if (localStorage.getItem('userInfo')) {
      tUserInfo = JSON.parse(localStorage.getItem('userInfo'));
    }

    if (tUserInfo.refreshtoken) {

      await API.post('/api/shared/user-management/auth/refresh-token', {
        refreshToken: tUserInfo.refreshtoken
      }).then(result => {
        tUserInfo = {
          ...tUserInfo,
          accesstoken: result.data.accesstoken,
          expiresat: result.data.expiresat,
          refreshtoken: result.data.refreshtoken,
          refreshtokenexpiresat: result.data.refreshtokenexpiresat,
          features: result?.data?.features?.length > 0 ? result.data.features : []
        };
      });

      localStorage.setItem('userInfo', JSON.stringify(tUserInfo));
      setUserInfo(tUserInfo);
    }
  }

  useEffect(() => {
    initializeIcons();
    getUserData();
    loadMessages(messagesMn);
    locale('mn');
    signalrHub.onRefreshPermission = onRefreshPermission;
  }, []);

  return (
    <UserContext.Provider value={{ userInfo, setUserInfo }}>
      <Router>
        <MainNav userInfo={userInfo} />
      </Router>
      {/* <div>
        {window?.location?.hostname != 'localhost' && (
          <MessengerCustomerChat
            pageId="107097948850437"
            appId="795641121489149"
          />
        )}
      </div> */}
      <div>
        {window?.location?.hostname != 'localhost' && (
          <FacebookProvider appId="795641121489149" chatSupport>
            <CustomChat pageId="107097948850437" minimized={false} />
          </FacebookProvider>
        )}
      </div>
      <LoadScreen />
    </UserContext.Provider >
  );
}

export default App;
